import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import { connectivityDashboardActions } from '../reducers/connectivity-dashboard';
import connectivityDashboardService from '../api/connectivityDashboard';
import { AssetsLengthRequestPayloadTypes } from '../models/connectivity-dashboard';

function* conDashboardDataRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchConDashboard, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getConDashboardDataResponse(res));
  } else {
    yield put(connectivityDashboardActions.getConDashboardDataFailed(res?.code));
  }
}

// Assets
function* assetsRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssets, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetsResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetsFailed(res?.code));
  }
}

function* assetsLatestRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssetsLatest, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetsLatestResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetsLatestFailed(res?.code));
  }
}

function* assetsLengthRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssetsLength, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetsLengthResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetsLengthFailed(res?.code));
  }
}

// Gateways
function* gatewaysLengthRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchGatewaysLength, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getGatewaysLengthResponse(res));
  } else {
    yield put(connectivityDashboardActions.getGatewaysLengthFailed(res?.code));
  }
}

function* gatewaysLatestRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchGatewaysLatest, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getGatewaysLatestResponse(res));
  } else {
    yield put(connectivityDashboardActions.getGatewaysLatestFailed(res?.code));
  }
}

function* gatewaysRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchGateways, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getGatewaysResponse(res));
  } else {
    yield put(connectivityDashboardActions.getGatewaysFailed(res?.code));
  }
}

// MQ Broker
function* mqBrokerLengthRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchMQBrokerLength, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getMQBrokerLengthResponse(res));
  } else {
    yield put(connectivityDashboardActions.getMQBrokerLengthFailed(res?.code));
  }
}

function* mqBrokerRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchMQBroker, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getMQBrokerResponse(res));
  } else {
    yield put(connectivityDashboardActions.getMQBrokerFailed(res?.code));
  }
}

// Influx
function* influxLengthRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchInfluxLength, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getInfluxLengthResponse(res));
  } else {
    yield put(connectivityDashboardActions.getInfluxLengthFailed(res?.code));
  }
}

function* influxRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchInflux, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getInfluxResponse(res));
  } else {
    yield put(connectivityDashboardActions.getInfluxFailed(res?.code));
  }
}

// UI Server
function* uiServerLengthRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchUIServerLength, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getUIServerLengthResponse(res));
  } else {
    yield put(connectivityDashboardActions.getUIServerLengthFailed(res?.code));
  }
}

function* uiServerRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchUIServer, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getUIServerResponse(res));
  } else {
    yield put(connectivityDashboardActions.getUIServerFailed(res?.code));
  }
}

// Backend Server
function* backendServerLengthRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchBackendServerLength, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getBackendServerLengthResponse(res));
  } else {
    yield put(connectivityDashboardActions.getBackendServerLengthFailed(res?.code));
  }
}

function* backendServerRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchBackendServer, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getBackendServerResponse(res));
  } else {
    yield put(connectivityDashboardActions.getBackendServerFailed(res?.code));
  }
}

function* notificationsLatestRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchNotificationsLatest, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getNotificationsLatestResponse(res));
  } else {
    yield put(connectivityDashboardActions.getNotificationsLatestFailed(res?.code));
  }
}

function* notificationsRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchNotifications, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getNotificationsResponse(res));
  } else {
    yield put(connectivityDashboardActions.getNotificationsFailed(res?.code));
  }
}

function* assetsOnboardingDataRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssetsOnboardingData, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetsOnboardingDataResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetsOnboardingDataFailed(res?.code));
  }
}

function* telemetryIngestionDataRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchTelemetryIngestionData, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getTelemetryIngestionDataResponse(res));
  } else {
    yield put(connectivityDashboardActions.getTelemetryIngestionDataFailed(res?.code));
  }
}

function* assetsHistoryDataRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssetsHistory, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetsHistoryDataResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetsHistoryDataFailed(res?.code));
  }
}

// Assets Latest Polling
function* assetsLatestPollingRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssets, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetsLatestPollingResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetsLatestPollingFailed(res?.code));
  }
}

// Assets Polling
function* assetsPollingRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssets, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetsPollingResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetsPollingFailed(res?.code));
  }
}

// Gateways Latest Polling
function* gatewaysLatestPollingRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchGateways, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getGatewaysLatestPollingResponse(res));
  } else {
    yield put(connectivityDashboardActions.getGatewaysLatestPollingFailed(res?.code));
  }
}

// Gateways Polling
function* gatewaysPollingRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchGateways, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getGatewaysPollingResponse(res));
  } else {
    yield put(connectivityDashboardActions.getGatewaysPollingFailed(res?.code));
  }
}

// Assets History Polling
function* assetsHistoryPollingDataRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssetsHistory, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetsHistoryPollingDataResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetsHistoryPollingDataFailed(res?.code));
  }
}

// EMQX - MQTT Count
function* emqxInfluxCountRequest({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchEmqxInfluxCount, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getEmqxInfluxCountResponse(res));
  } else {
    yield put(connectivityDashboardActions.getEmqxInfluxCountFailed(res?.code));
  }
}

function* assetsPropertiesDataReq({ payload }: any): any {
  const res = yield call(connectivityDashboardService.fetchAssetProperties, payload);
  if (res.status === 'success') {
    yield put(connectivityDashboardActions.getAssetPropertiesDataResponse(res));
  } else {
    yield put(connectivityDashboardActions.getAssetPropertiesDataFailed(res?.code));
  }
}

function* connectivityDashboardSaga() {
  yield takeLatest('conDashboard/getConDashboardDataRequest', conDashboardDataRequest);
  yield takeLatest('conDashboard/getAssetsRequest', assetsRequest);
  // yield takeLatest('conDashboard/getAssetsLengthRequest', assetsLengthRequest);
  yield takeLatest('conDashboard/getAssetsLatestRequest', assetsLatestRequest);
  yield takeLeading('conDashboard/getAssetsLatestPollingRequest', assetsLatestPollingRequest);
  // yield takeLatest('conDashboard/getGatewaysLengthRequest', gatewaysLengthRequest);
  yield takeLatest('conDashboard/getGatewaysLatestRequest', gatewaysLatestRequest);
  yield takeLeading('conDashboard/getGatewaysLatestPollingRequest', gatewaysLatestPollingRequest);
  yield takeLatest('conDashboard/getGatewaysRequest', gatewaysRequest);
  yield takeLatest('conDashboard/getMQBrokerLengthRequest', mqBrokerLengthRequest);
  yield takeLatest('conDashboard/getMQBrokerRequest', mqBrokerRequest);
  yield takeLatest('conDashboard/getInfluxLengthRequest', influxLengthRequest);
  yield takeLatest('conDashboard/getInfluxRequest', influxRequest);
  yield takeLatest('conDashboard/getUIServerLengthRequest', uiServerLengthRequest);
  yield takeLatest('conDashboard/getUIServerRequest', uiServerRequest);
  yield takeLatest('conDashboard/getBackendServerLengthRequest', backendServerLengthRequest);
  yield takeLatest('conDashboard/getBackendServerRequest', backendServerRequest);
  yield takeLatest('conDashboard/getNotificationsLatestRequest', notificationsLatestRequest);
  yield takeLatest('conDashboard/getNotificationsRequest', notificationsRequest);
  yield takeLatest('conDashboard/getAssetsOnboardingDataRequest', assetsOnboardingDataRequest);
  yield takeLatest('conDashboard/getTelemetryIngestionDataRequest', telemetryIngestionDataRequest);
  yield takeLatest('conDashboard/getAssetsHistoryDataRequest', assetsHistoryDataRequest);
  yield takeLeading('conDashboard/getAssetsPollingRequest', assetsPollingRequest);
  yield takeLeading('conDashboard/getGatewaysPollingRequest', gatewaysPollingRequest);
  yield takeLeading('conDashboard/getAssetsHistoryPollingDataRequest', assetsHistoryPollingDataRequest);
  yield takeLeading('conDashboard/getEmqxInfluxCountRequest', emqxInfluxCountRequest);
  yield takeLeading('conDashboard/getAssetPropertiesDataRequest', assetsPropertiesDataReq);
}

export default connectivityDashboardSaga;
